import { createAsyncThunk } from '@reduxjs/toolkit'
import EmployeeConfig from '../../../services/api/EmployeeConfig'
import RestClient from '../../../services/client/RestClient'
import { addToArrIfNotExistOrRemove } from '../../../utils/helpers'

const { Import_Users_Roles_Details_Endpoints } = EmployeeConfig
export const importUsersRolesDetailsResetAlertHandler = createAsyncThunk(
  'importUsersRolesDetails/importUsersRolesDetailsResetAlertHandler',
  async () => ({}),
)

export const retrieveImportUsersRolesDetailsByID = createAsyncThunk(
  'importUsersRolesDetails/retrieveImportUsersRolesDetailsByID',
  async ({ queries }, { rejectWithValue }) => {
    const api = Import_Users_Roles_Details_Endpoints(queries)
    const response = await RestClient.getRequest(`${api.getImportUsersRolesDetails}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response
  },
)

function createReqHelper(store, { key, value }) {
  const copyStore = { ...store }
  if (key) {
    copyStore[key] = value
  }
  const getFilterIds = (filters) => (filters || []).map((filter) => filter.id)
  const filterStatusIds = getFilterIds(copyStore?.activeFilters)?.join('&status_ids=')

  const {
    activeSearch,
    pageSize,
    activeSort,
    pageNumber,
  } = copyStore

  const response = [
    `search=${activeSearch}`,
    `page_number=${pageNumber || 0}`,
    `page_size=${pageSize}`,
    `sort_by=${activeSort?.key || ''}`,
    `status_ids=${filterStatusIds}`,
  ].join('&')
  return response
}

export const retrieveImportUsersRolesDetailsListByID = createAsyncThunk(
  'importUsersRolesDetails/retrieveImportUsersRolesDetailsListByID',
  async ({ queries }, { getState, rejectWithValue }) => {
    const api = Import_Users_Roles_Details_Endpoints(queries)
    const { importUsersRolesDetails } = getState()
    const filters = createReqHelper(importUsersRolesDetails, {})
    const response = await RestClient.getRequest(`${api.getImportUsersRolesDetailsUsers}?${filters}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return { response: response.data, batchId: queries }
  },
)

export const filterImportUsersRolesDetailsList = createAsyncThunk(
  'importUsersRolesDetails/filterImportUsersRolesDetailsList',
  async ({ queries }, { getState, rejectWithValue }) => {
    const { importUsersRolesDetails } = getState()
    const api = Import_Users_Roles_Details_Endpoints(importUsersRolesDetails.batchId)
    let newFilterArr

    if (queries === 'clear') {
      newFilterArr = []
    } else if (Array.isArray(queries)) {
      newFilterArr = queries
    } else {
      newFilterArr = addToArrIfNotExistOrRemove(importUsersRolesDetails.activeFilters, 'id', queries)
    }

    const filters = createReqHelper(importUsersRolesDetails, { key: 'activeFilters', value: newFilterArr })
    const response = await RestClient.getRequest(`${api.getImportUsersRolesDetailsUsers}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return { response: response.data, filter: newFilterArr }
  },
)

export const searchImportUsersRolesDetailsList = createAsyncThunk(
  'importUsersRolesDetails/searchImportUsersRolesDetailsList',
  async ({ queries }, { getState, rejectWithValue }) => {
    const { importUsersRolesDetails } = getState()
    const api = Import_Users_Roles_Details_Endpoints(importUsersRolesDetails.batchId)
    const filters = createReqHelper(importUsersRolesDetails, { key: 'activeSearch', value: queries || '' })
    const response = await RestClient.getRequest(`${api.getImportUsersRolesDetailsUsers}?${filters}`)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return {
      response: response.data,
      search: queries || '',
    }
  },
)
export const importUsersRolesDetailsListPagination = createAsyncThunk(
  'importUsersRolesDetails/importUsersRolesDetailsListPagination',
  async ({ queries }, { getState, rejectWithValue }) => {
    const { importUsersRolesDetails } = getState()
    const api = Import_Users_Roles_Details_Endpoints(importUsersRolesDetails.batchId)
    const filters = createReqHelper(importUsersRolesDetails, { key: 'pageNumber', value: queries })
    const response = await RestClient.getRequest(`${api.getImportUsersRolesDetailsUsers}?${filters}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
      pageNumber: queries,
    }
  },
)
export const downloadFailedFile = createAsyncThunk(
  'importUsersRolesDetails/downloadFailedFile',
  async ({ queries }, { rejectWithValue }) => {
    const apiUri = Import_Users_Roles_Details_Endpoints(queries?.processId)
    const response = await RestClient.getRequest(`${apiUri.downloadFailedFile}`, { responseType: 'blob' })

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    if (response.data) {
      const contentDisposition =
         response.headers['content-disposition'] ||
         response.headers['Content-Disposition']

      let filename = queries?.name || 'download.xlsx';

      if (contentDisposition) {
        const rfc5987Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (rfc5987Match) {
          filename = decodeURIComponent(rfc5987Match[1]);
        } else {
          const standardMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
          if (standardMatch) {
            filename = standardMatch[1];
          }
        }
      }

      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      const url = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }
    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)
